export interface ProfileType {
  id: number;
  mail: string;
  firstName: string;
  lastName: string;
  description: string | null;
  telNumber: string | null;
  golfId: string | null;
  handicap: number;
  genderType: number;
  isMember: boolean;
  paymentType: string;
  currency: 'SEK' | 'EUR' | unknown;
  countryCode: string;
  memberIn: number | null;
  ghCardNr: string | null;
  ghEmail: string | null;
  gitPersonId: string | null;
  gitSessionId: string | null;
  nationalityCountryCode: string | null;
  createdBy: number;
  guestProfile: boolean;
  guestProfileApproved: boolean | null;
}

export enum GolfIdVerificationStatus {
  UNKNOWN = 'UNKNOWN',
  NOT_AVAILABLE = 'NOT_AVAILABLE',
  REQUIRED = 'REQUIRED',
  VERIFIED = 'VERIFIED',
}
